import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { CircleNotch } from "@phosphor-icons/react";
import Landing from "@/pages/Landing";

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const { pathname } = useLocation();
  if (loading || user === null) {
    return (
      <div className="flex h-screen items-center justify-center bg-background">
        <CircleNotch size={32} className="animate-spin text-primary" />
      </div>
    );
  }
  if (!user) return pathname === "/" ? <Landing /> : <Navigate to="/login" replace />;
  return children;
}
